// @ts-expect-error Web-only. On RN, this is set by Metro.
window.__BUNDLE_START_TIME__ = performance.now()
